import AddButton from 'components/buttons/AddButton'
import PathologyAction from 'components/data-table/data-table-action/superadmin-actions/PathologyAction';
import DataTable from 'components/data-table/DataTable'
import Loader from 'components/loader/Loader'
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Container, Row } from 'reactstrap'
import { PathologyListRes, PathologyListTodo } from 'redux/slice/super-admin/pathology/PathologyList';

class PathologyList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bool: false
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        dispatch(PathologyListTodo()).then(() => this.List_res());
    }

    componentDidUpdate(prevProps, prevState) {
        const { dispatch } = this.props;
        if (prevState.bool !== this.state.bool) {
            dispatch(PathologyListTodo()).then(() => this.List_res());
        }
    }

    setBool = () => {
        this.setState(prevState => ({ bool: !prevState.bool }));
    }


    List_res = () => {
        if (PathologyListRes?.status) {
            this.setState({ loading: false });
        } else {
            this.setState({ loading: false });
        }
    }
    render() {

        const { loading, bool } = this.state;
        const { pathologyList } = this.props;
        const columnDefs = [
            {
                headerName: 'S.NO',
                valueGetter: 'node.rowIndex + 1',
                filter: 'false',
                suppressMenu: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 90
            },
            {
                headerName: 'PATHOLOGY',
                field: 'company_name',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            // {
            //     headerName: 'IMAGE',
            //     field: 'cust_logo',
            //     cellRenderer: params => <div className='table_img_sec'>
            //         <img className=" img-fluid table_data_img" src={process.env.REACT_APP_IMAGE_URL + params?.data?.cust_logo } alt="image" />
            //     </div>,
            //     filter: 'agTextColumnFilter',
            //     suppressMenu: true,
            //     autoHeight: true,
            //     filter: true,
            //     sortable: true,
            //     floatingFilter: false,
            //     maxWidth: 120,
            //     // wrapText: true,
            //     // autoHeight: true,
            // },

            {
                headerName: 'EMAIL',
                field: 'email_id',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'Administrative',
                field: 'contact_person',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'CONTACT',
                field: 'phone_no',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 130
            },
            {
                headerName: 'CITY',
                field: 'city_name.city',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120
            },
            {
                headerName: 'STATUS',
                field: 'status',
                filter: 'agTextColumnFilter',
                // cellRenderer: params => (
                //     <span className={params.value === 'Active' ? 'badge bg-success' : 'badge bg-danger'}>
                //         {params.value}
                //     </span>
                // ),
                cellRenderer: params => params.value === 'Active' ? <span className='active-status'>Active</span> : <span className='inactive-status'>Inactive</span>,
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120
            },
            {
                field: 'ACTIONS',
                cellRenderer: PathologyAction,
                cellRendererParams: {
                    bool: bool,
                    setBool: this.setBool,
                },
                autoHeight: true,
                pinned: 'right',
                maxWidth: 120,
            }
        ];
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h4 className="mb-0 font-size-18">Pathology List</h4>
                            <Link to='/superadmin/add-pathology'> <AddButton name={"ADD PATHOLOGY"} /></Link>
                        </div>
                        <Row>
                            <Col xl='12' className='mt-2'>
                                {loading ?
                                    <div className='dd-flex justify-content-center p-5'>
                                        <Loader />
                                    </div> :
                                    pathologyList?.length ?
                                        <DataTable
                                            rowData={pathologyList}
                                            columnDefs={columnDefs}
                                            height={'70vh'}
                                        />
                                        :
                                        <div className='empty_section'>
                                            <h4>DATA NOT FOUND</h4>
                                        </div>}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    pathologyList: state?.PathologyList?.data?.data,
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(PathologyList)
